import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveCourseFromCandidateResponse extends BackendResponse {}
export interface RemoveCourseFromCandidateParameters extends NextApiParams {
  courseId: number;
}

export const removeCourseFromCandidate = withNextApi<
  RemoveCourseFromCandidateResponse,
  RemoveCourseFromCandidateParameters
>("/cvp/CvpRemoveCourseFromCandidate");
